import * as yup from 'yup'
import { defineMessages } from 'react-intl'

const taxonomyMessages = defineMessages({
  required: {
    id: 'fares.form.taxonomy.incorrect',
    defaultMessage: 'Incorrect'
  }
})

const basePriceMessages = defineMessages({
  required: {
    id: 'fares.form.basePrice.required',
    defaultMessage: 'Required'
  }
})

// @ts-expect-error TS(2559) FIXME Remove this comment to see the full error message
export const schema = (intl): TSFixMe => {
  return yup.object().shape({
    fares: yup.array().of(
      yup.object().shape({
        basePrice: yup.string().required(intl.formatMessage(basePriceMessages.required)),
        bookingClass: yup.object().shape({
          id: yup.string().required(intl.formatMessage(taxonomyMessages.required))
        }),
        type: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        seasonType: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        timeWindow: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        dow: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        demand: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        salesChannel: yup.string().required(intl.formatMessage(taxonomyMessages.required)),
        serviceType: yup.string().required(intl.formatMessage(taxonomyMessages.required))
      })
    )
  })
}
